module.exports = __webpack_public_path__ + "img/naveen.155b5603.png";